import React, { Component } from 'react';
import connect from 'react-redux/es/connect/connect';
import { createSelector } from 'reselect';
import { Dialog, DialogTitle, DialogContent, Typography, IconButton } from '@material-ui/core';
//import CloseIcon from '@material-ui/icons/Close';
import SimpleReactValidator from 'simple-react-validator';
import LaddaButton, { EXPAND_RIGHT } from 'react-ladda';
import { StripeProvider, Elements, injectStripe, CardNumberElement, CardExpiryElement, CardCVCElement } from 'react-stripe-elements';
import { Alert } from '@material-ui/lab';
import { itemService, globalService as gs } from '../../../common/services';
import { alertSelectors } from '../../../common/redux/selectors';

const createOptions = (fontSize, padding) => {
    return {
      style: {
        base: {
          fontSize,
          color: '#495057',
          fontWeight: '100',
          letterSpacing: '0.025em',
          '::placeholder': {
            color: '#000',
          },
          padding,
        },
        invalid: {
          color: '#9e2146',
        },
      },
    };
};

class _CardForm extends React.Component {
    constructor(props) {

        super(props);
        this.state = {
            formField: {
                first_name: '',
                last_name: '',
                email: '',
                amount: '',
                token: { id: '', email: '' }
            },
            loading: false,
            errorMessage: '',
        };
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            className: 'valid-feedback d-block text-danger',
        });
    }

    handleChange = (e) => {
        const { name, value, checked, type } = e.target;
        let formField = {...this.state.formField};
        formField[name] = (type === 'checkbox') ? (checked === true) ? 1 : '' : value;
        this.setState({formField});
    };

    handleError = ({error}) => {
        if (error) {
          this.setState({errorMessage: error.message});
        }
    };

    handleSubmit = (e) => {
        e.preventDefault();
        if( this.validator.allValid() ) {
            this.setState({loading: true});
            const { stripe } = this.props;
            const { formField } = this.state;
            if (stripe) {
                stripe.createToken({price: formField.amount, name: formField.first_name, email: formField.email}).then((payload) => {
                    console.log('payload', payload)
                    //this.setState({loading: false});
                    //return false;
                    if(payload && payload.token) {
                        formField['token'].id = payload.token.id;
                        formField['token'].email = payload.token.email;
                        this.apply(formField);
                    } else {
                        //console.log("Stripe.js hasn't loaded yet.");
                        this.setState({loading: false, errorMessage: payload.error.message});
                    }
                });
            }
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    };

    apply = (formField) => {
        delete formField.email;
        const { dispatch } = this.props;
        itemService.donation("POST", formField).then(data => {
            dispatch(alertSelectors.success('You have successfully donate.'));
            this.handleClose('done');
        }).catch(exception => {
            gs.showErrors(dispatch, exception, alertSelectors);
            this.setState({loading: false});
        });
    }

    handleClose = (e = null) => this.props.handleClose(e);

    render() {
        this.validator.purgeFields();
        const { formField, loading } = this.state;
        return (<form name="form" onSubmit={this.handleSubmit} noValidate>
            <div className="row">
                <div className="col-md-6 col-12">
                    <div className="form-group">
                        <label>First Name</label>
                        <input type="text" className="form-control" placeholder="Enter" name="first_name" value={formField.first_name} onChange={this.handleChange} />
                        {this.validator.message('first_name', formField.first_name, 'required')}
                    </div>
                </div>
                <div className="col-md-6 col-12">
                    <div className="form-group">
                        <label>Last Name</label>
                        <input type="text" className="form-control" placeholder="Enter" name="last_name" value={formField.last_name} onChange={this.handleChange} />
                        {this.validator.message('last_name', formField.last_name, 'required')}
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 col-12">
                    <div className="form-group">
                        <label>Email</label>
                        <input type="text" className="form-control" placeholder="Enter" name="email" value={formField.email} onChange={this.handleChange} />
                        {this.validator.message('email', formField.email, 'required|email')}
                    </div>
                </div>
                <div className="col-md-6 col-12">
                    <div className="form-group">
                        <label>Amount</label>
                        <input type="text" className="form-control" placeholder="Enter" name="amount" value={formField.amount} onChange={this.handleChange} />
                        {this.validator.message('amount', formField.amount, 'required|numeric')}
                    </div>
                </div>
            </div>
            <div className="card-details">
                <h3 className="font-weight-bold">Payment Detail</h3>
                <div className="row">
                    <div className="col-md-12 col-12">
                        <div className="form-group">
                            <label>Card number</label>
                            <CardNumberElement
                                onChange={this.handleError}
                                {...createOptions(this.props.fontSize)}
                            />
                        </div>
                    </div>
                    <div className="col-md-6 col-12">
                        <div className="form-group">
                            <label>Expiration date</label>
                            <CardExpiryElement
                                onChange={this.handleError}
                                {...createOptions(this.props.fontSize)}
                            />
                        </div>
                    </div>
                    <div className="col-md-6 col-12">
                        <div className="form-group">
                            <label>CVC</label>
                            <CardCVCElement
                                onChange={this.handleError}
                                {...createOptions(this.props.fontSize)}
                            />
                        </div>
                    </div>
                </div>
                {this.state.errorMessage && <div className="form-group">
                    <Alert severity="error">{this.state.errorMessage}</Alert>
                </div>}
            </div>
            <div className="form-group">
                <LaddaButton type="submit" className="btn btn-secondary text-white text-uppercase" loading={loading} data-style={EXPAND_RIGHT}>Pay Now</LaddaButton>
            </div>
        </form>)
    }
}

const CardForm = injectStripe(_CardForm);

class DonationForm extends Component {

    handleClose = (e = null) => this.props.handleClose(e);

    render() {
        const { open, item, dispatch, authentication } = this.props;
        return (<Dialog onClose={this.handleClose} open={open} className="booking-dialog" scroll={"body"}>
            <DialogTitle id="simple-dialog-title" disableTypography className="bg-info text-white text-center">
                <Typography variant="h6">Donation Form</Typography>
                <IconButton aria-label="close" className="closeButton" onClick={this.handleClose}>
                <i className="fas fa-times"></i>
                </IconButton>
            </DialogTitle>
            <DialogContent >
                <StripeProvider apiKey={process.env.REACT_APP_STRIPE_TEST_PUBLIC_KEY}>
                    <Elements>
                        <CardForm fontSize="16px" item={item && item} dispatch={dispatch} authentication={authentication && authentication} handleClose={(e) => this.handleClose(e)} />
                    </Elements>
                </StripeProvider>
            </DialogContent>
        </Dialog>);
    }
}

const authenticationSelector = createSelector(
    state => state.authentication,
    authentication => authentication
);

const processSelector = createSelector(
    state => state.process,
    process => process
);

const mapStateToProps = createSelector(
    processSelector,
    authenticationSelector,
    (process, authentication) => ({
        process, authentication
    })
);

export default connect(mapStateToProps)(DonationForm);